import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";

import { Navbar } from "./components/Navbar/Navbar";
import Sortlist from "./components/Sortlist/Sortlist";
import TopHalf from "./components/TopHalf/TopHalf";
import axios from "axios";
import TokenList from "./components/TokenList/TokenList";
import EmailSubcription from "./components/EmailSubcription/EmailSubcription";
import Footer from "./components/Footer/Footer";
function App() {
  const [users, setUsers] = useState([]);
  const [active, setActive] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const getRandomNumber = (min, max) => {
    return Math.random() * (max - min) + min;
  };
  const [tokens, setTokens] = useState([]);
  const [data, setData] = useState({
    marketCap: Math.floor(getRandomNumber(500_000_000, 2_000_000_000)), // random market cap
    volume: Math.floor(getRandomNumber(50_000_000, 500_000_000)), // random volume
    marketCapChange: getRandomNumber(-5, 5), // random -5% to +5%
    volumeChange: getRandomNumber(-10, 10), // random -10% to +10%
  });

  const [prevVolume, setPrevVolume] = useState(null);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://api.coingecko.com/api/v3/coins/markets",
        {
          params: {
            vs_currency: "usd",
            category: "real-estate",
            per_page: 250,
            page: 1,
            price_change_percentage: "24h",
          },
        }
      );

      const coins = res.data;

      let totalMarketCap = 0;
      let weightedChange = 0;
      let totalVolume = 0;

      coins.forEach((coin) => {
        totalMarketCap += coin.market_cap || 0;
        totalVolume += coin.total_volume || 0;

        if (coin.market_cap && coin.market_cap_change_percentage_24h !== null) {
          weightedChange +=
            coin.market_cap * coin.market_cap_change_percentage_24h;
        }
      });

      const marketCapChange =
        totalMarketCap > 0 ? weightedChange / totalMarketCap : 0;

      let volumeChange = getRandomNumber(-20, 20);
      if (prevVolume) {
        volumeChange = ((totalVolume - prevVolume) / prevVolume) * 100;
      }

      setPrevVolume(totalVolume);

      setData({
        marketCap: totalMarketCap,
        volume: totalVolume,
        marketCapChange,
        volumeChange,
      });
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full ">
      <Navbar tokens={tokens} setTokens={setTokens} />
      <Sortlist />
      <TopHalf tokens={tokens} data={data} />
      <TokenList tokens={tokens} setTokens={setTokens} />
      <EmailSubcription />
      <Footer />
    </div>
  );
}

export default App;
